import React from "react";

const BrandPanelClip = () => (
  <svg width="0" height="0" aria-hidden="true" style={{ position: "absolute" }}>
    <defs>
      <clipPath id="loginBrandClip" clipPathUnits="objectBoundingBox">
        <path d="M 0,0 L 0.96,0 C 0.82,0.22 0.82,0.78 0.96,1 L 0,1 Z" />
      </clipPath>
    </defs>
  </svg>
);

export default BrandPanelClip;
